// Generated file - do not change manually!
/**
 * Defines different types of MessageStrip.
 */
export var MessageStripDesign;
(function (MessageStripDesign) {
    /**
     * Message should be just an information
     */
    MessageStripDesign["Information"] = "Information";
    /**
     * Message is an error
     */
    MessageStripDesign["Negative"] = "Negative";
    /**
     * Message is a success message
     */
    MessageStripDesign["Positive"] = "Positive";
    /**
     * Message is a warning
     */
    MessageStripDesign["Warning"] = "Warning";
})(MessageStripDesign || (MessageStripDesign = {}));
